import type { Option } from '@components/forms/GridSelect';

export enum SystemFilterOption {
    Model = 'model',
    Status = 'status',
}

export enum SystemAssigned {
    Assigned = 'assigned',
    Unassigned = 'unassigned',
}

export enum System {
    RapidCut = 'RC2/RC3',
    RCMini = 'RCMini',
}

export enum SystemModel {
    RC = 0,
    RCMINI = 1,
}

export enum SystemStatus {
    Active = 'Active',
    Inactive = 'Inactive',
}

export const SystemModelMap: { [key: string]: System } = {
    0: System.RapidCut,
    1: System.RCMini,
};

export const SYSTEM_STATUS_OPTIONS: Option[] = Object.entries(SystemStatus).map(([label, value]) => {
    return {
        label,
        value,
    };
});

export const COMPATIBILITY_OPTIONS = [System.RCMini, System.RapidCut];
